import { Injectable, inject } from '@angular/core';
import { MapSettings } from '../interfaces';
import { RestApiService } from '@core/services/rest-api.service';
import { Observable, map, of, tap } from 'rxjs';
import { MapSetting } from '../constants/constants';
import { Entity } from '@shared/constants/entity';
import {
  GetUserSettingResp,
  UpsertUserSettingPayload,
} from '@shared/interfaces/user-setting';

@Injectable({ providedIn: 'root' })
export class MapToolbarSettingsService {
  private api = inject(RestApiService);

  private currentMapSettings: MapSettings = {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getMapSettingsBySettingName(mapSetting: MapSetting): Observable<any> {
    return this.currentMapSettings[mapSetting]
      ? of(this.currentMapSettings[mapSetting].Value)
      : this.api
          .getCustom<
            GetUserSettingResp | undefined
          >(`UserSetting/Id/${mapSetting}`)
          .pipe(
            map(resp => {
              if (resp) {
                this.currentMapSettings[mapSetting] = {
                  UserSettingId: resp.UserSettingId,
                  Value: JSON.parse(resp.Value || ''),
                };

                return this.currentMapSettings[mapSetting].Value;
              }
              return;
            })
          );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setMapSettingsBySettingName(mapSetting: MapSetting, settings: any): void {
    if (
      JSON.stringify(settings) ===
      JSON.stringify(this.currentMapSettings[mapSetting]?.Value)
    )
      return;

    const payload: UpsertUserSettingPayload = {
      Id: mapSetting,
      Value: JSON.stringify(settings),
    };
    this.api
      .upsert(
        Entity.Preference,
        this.currentMapSettings[mapSetting]?.UserSettingId || '0',
        payload
      )
      .pipe(
        tap(id => {
          if (id) {
            this.currentMapSettings[mapSetting] = {
              Value: settings,
              UserSettingId: id,
            };
          } else {
            this.currentMapSettings[mapSetting]!.Value = settings;
          }
        })
      )
      .subscribe();
  }
}
